"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RactiveComponentsInitializerDefinition = void 0;
const WidgetInitializerPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPlugin");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const QuestionnaireRenderComponent_1 = require("../RenderComponent/QuestionnaireRenderComponent");
const WidgetInitializerPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPluginDefinition");
const RactiveComponentPluginDefinition_1 = require("auto-widget-framework/src/Plugin/RactiveComponent/RactiveComponentPluginDefinition");
const TemplateTypes_1 = require("../../Enum/TemplateTypes");
const DateInputComponent_1 = require("../RenderComponent/DateInputComponent");
/**
 * Initializes template and css for the widget.
 */
class RactiveComponentsInitializer extends WidgetInitializerPlugin_1.default {
    constructor(definition, ractivePluginManager) {
        super(definition);
        this.ractivePluginManager = ractivePluginManager;
    }
    /**
     * @inheritDoc
     */
    static create(definition, container) {
        return new this(definition, container.get('plugin.manager.ractive_component'));
    }
    /**
     * @inheritDoc
     */
    initialize(config, state) {
        return Promise.resolve().then(() => {
            const definitions = [
                new RactiveComponentPluginDefinition_1.default({
                    id: "date_input_component",
                    class: DateInputComponent_1.default,
                    template: config.getTemplate(TemplateTypes_1.TemplateTypes.DATE_COMPONENT).getTemplate()
                }),
                new RactiveComponentPluginDefinition_1.default({
                    id: "questionnaire_component",
                    class: QuestionnaireRenderComponent_1.default,
                    template: config.getTemplate(TemplateTypes_1.TemplateTypes.QUESTIONNAIRE_COMPONENT).getTemplate()
                })
            ];
            definitions.forEach((def) => this.ractivePluginManager.addDefinition(def));
        });
    }
}
exports.default = RactiveComponentsInitializer;
exports.RactiveComponentsInitializerDefinition = new WidgetInitializerPluginDefinition_1.default({
    id: "ractive_component_initializer",
    class: RactiveComponentsInitializer,
    priority: 60,
});
Mixin_1.default(RactiveComponentsInitializer, IContainerInjection_1.default);
